<template>
  <div class="app-container">
    <el-card style="margin-bottom: 10px;" class="search-form">
      <el-form
        ref="queryFormRef"
        :model="queryForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$t('home.HolidayName')"
            >
              <el-select
                v-model="queryForm.params.name"
                :placeholder="$t('placeOrder.pleaseChoose')"
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in nameList"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('GlobalSetObj.Date')"
            >
              <el-date-picker
                v-model="queryForm.params.invoiceIssueTime"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--选择州或城市-->
            <el-form-item :label="$t('home.SelectStateCity')">
              <el-cascader
                v-model="queryForm.params.locations"
                :options="stateCityOptions"
                :props="{
                  multiple: true,
                  checkStrictly: true,
                  value: 'value',
                  label: 'label'
                }"
                :show-all-levels="false"
                clearable
                filterable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--选择客户-->
            <el-form-item :label="$t('orderCenterCont.SelectCustomers')">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                multiple
                reserve-keyword
                style="width: 100%"
                @visible-change="getCustomerList"
                @change="changeCustomerList()"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--选择商户-->
            <el-form-item :label="$t('home.SelectMerchant')">
              <el-select
                v-model="queryForm.params.merchantCodes"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getShanghu"
                clearable
                filterable
                remote
                multiple
                reserve-keyword
                size="small"
                style="width: 100%"
                @visible-change="getShanghuList"
              >
                <el-option
                  v-for="item in commercialList"
                  :key="item.code"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin-top: 28px;">
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="search"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="small"
                @click="onReset"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="margin-bottom: 10px;">
      <!--新增节假日-->
      <el-button type="primary" size="small" @click="addHoliday">{{ $t('home.AddHoliday') }}</el-button>
      <!--刷新历史数据-->
      <!--<el-button type="primary" size="small" @click="refreshHistoricalData">{{ $t('home.RefreshHistoricalData') }}</el-button>-->
    </div>
    <el-table
      :data="tableData"
      border
      class="table-height"
      :header-cell-style="{background:'#f2f2f2',color:'black'}"
      :height="tableHeightRow.height"
    >
      <el-table-column
        :label="$t('home.serialNumber')"
        type="index"
        width="80"
        align="center"
        fixed="left"
      >
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        :align="item.align"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'locationCount'">
            <div
              v-if="scope.row[item.prop]"
              style="color: #409eff;cursor: pointer"
              @click="getStateOrCityPage(scope.row)"
            >{{ scope.row[item.prop] }}</div>
            <div v-else>--</div>
          </div>
          <div v-else-if="item.prop === 'customerCount'">
            <div
              v-if="scope.row[item.prop]"
              style="color: #409eff;cursor: pointer"
              @click="getClientPage(scope.row)"
            >{{ scope.row[item.prop] }}</div>
            <div v-else>--</div>
          </div>
          <div v-else-if="item.prop === 'merchantCount'">
            <div
              v-if="scope.row[item.prop]"
              style="color: #409eff;cursor: pointer"
              @click="getCommercialOwnerPage(scope.row)"
            >{{ scope.row[item.prop] }}</div>
            <div v-else>--</div>
          </div>
          <div v-else-if="item.prop === 'date'">
            {{ scope.row.startDate }}~{{ scope.row.endDate }}
          </div>
          <div v-else-if="item.prop === 'type'">
            {{ scope.row.type === 1 ? $t('home.NationalHoliday') : $t('home.LocalHoliday') }}
          </div>
          <div v-else>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('singleScan.action')"
        align="center"
        fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <div class="operation_class">
            <el-button
              v-if="!scope.row.isExpired"
              type="text"
              size="mini"
              @click="editHoliday(scope.row)"
            >{{ $t('CenterForSorting.edit') }}</el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #f56c6c"
              @click="deleteHoliday(scope.row)"
            >{{ $t('CenterForSorting.Delete') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--新增、编辑-->
    <el-dialog
      :title="addEditType === 1 ? $t('home.AddHoliday') : $t('home.EditHoliday')"
      :visible.sync="showDataDetailWindow"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <addEditDetail
        ref="addEditDetailRef"
        :key="abnormalKey"
        :data-detail="dataDetail"
        :state-city-options="stateCityOptions"
        :selected-customer-list="selectedCustomerList"
        :merchant-list="merchantList"
        @updateTable="updateTable"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDataDetailWindow = false">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirmSave">{{ $t('collectionCenter.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--地点、客户、商户-->
    <el-dialog
      :title="detailType === 1 ? $t('customerManagements.address') : detailType === 2 ? $t('collectionCenter.client') : $t('collectionCenter.CommercialOwner')"
      :visible.sync="showDetailWindow"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <el-table
        ref="detailTableRef"
        :key="showDetailWindow"
        :data="detailTableData"
        border
        height="430px"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
      >
        <el-table-column
          :label="$t('home.serialNumber')"
          type="index"
          width="80"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--州-->
        <el-table-column
          v-if="detailType === 1"
          :label="$t('collectionCenter.state')"
          prop="state"
          align="center"
          :show-overflow-tooltip="true"
        />
        <!--城市-->
        <el-table-column
          v-if="detailType === 1"
          :label="$t('collectionCenter.city')"
          prop="city"
          align="center"
          :show-overflow-tooltip="true"
        />
        <!--客户-->
        <el-table-column
          v-if="detailType === 2"
          :label="$t('collectionCenter.client')"
          prop="username"
          align="center"
          :show-overflow-tooltip="true"
        />
        <!--商户-->
        <el-table-column
          v-if="detailType === 3"
          :label="$t('collectionCenter.CommercialOwner')"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.merchantName }} ({{ scope.row.merchantCode }})
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import addEditDetail from './cmp/addEditDetail.vue';
import { apiCustomerPage, apimerchantName } from '@/api/customer';
import { holidayDelete, holidayNameApi, holidayPage, provinceAndCityApi } from '@/api/newExpressAPI';
export default {
  components: { addEditDetail },
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          invoiceIssueTime: [],
          name: null,
          customerIds: [],
          merchantCodes: [],
          locations: []
        }
      },
      tableData: [],
      total: 0,
      tableHeaderList: [
        // 创建时间
        { label: this.$t('operationCenter.CreationTime'), prop: 'createTime', cloWidth: '180', align: 'center' },
        // 假期名称
        { label: this.$t('home.HolidayName'), prop: 'name', cloWidth: '180', align: 'center' },
        // 日期
        { label: this.$t('operationCenter.date'), prop: 'date', cloWidth: '180', align: 'center' },
        // 天数
        { label: this.$t('home.Days'), prop: 'days', cloWidth: '180', align: 'center' },
        // 假期类型
        { label: this.$t('home.HolidayType'), prop: 'type', cloWidth: '180', align: 'center' },
        // 州或城市
        { label: this.$t('home.StateOrCity'), prop: 'locationCount', cloWidth: '180', align: 'center' },
        // 客户
        { label: this.$t('operationCenter.client'), prop: 'customerCount', cloWidth: '180', align: 'center' },
        // 商户
        { label: this.$t('placeOrder.CommercialOwner'), prop: 'merchantCount', cloWidth: '180', align: 'center' },
        // 创建人
        { label: this.$t('CenterForSorting.creator'), prop: 'createUserName', cloWidth: '180', align: 'center' },
        // 最新修改时间
        { label: this.$t('home.LatestModificationTime'), prop: 'updateTime', cloWidth: '180', align: 'center' },
        // 最新修改人
        { label: this.$t('home.LatestModifier'), prop: 'updateUserName', cloWidth: '180', align: 'center' }
      ],
      addEditType: 1, // 1 新增 2 修改
      dataDetail: {
        name: '',
        date: [],
        type: null,
        targetLocations: [],
        targetCustomerIds: [],
        targetMerchantCodes: []
      },
      showDataDetailWindow: false,
      abnormalKey: new Date().getTime(),
      showDetailWindow: false,
      detailType: 1, // 1 地址 2 客户  3 商户
      detailTableData: [],
      customerList: [],
      commercialList: [],
      nameList: [],
      stateCityOptions: [],
      selectedCustomerList: [],
      merchantList: []
    };
  },
  created() {
    this.getNameData();
    this.getTableData();
    this.getProvinceAndCity();
  },
  methods: {
    // 刷新历史数据
    // refreshHistoricalData() {},
    // 客户选项变化
    changeCustomerList() {
      this.queryForm.params.merchantCodes = [];
      if (this.queryForm.params.customerIds.length > 0) {
        this.getShanghu();
      } else {
        this.commercialList = [];
      }
    },
    // 客户选项打开
    getCustomerList(val) {
      if (val) {
        this.getCustomerPage();
      }
    },
    // 打开商户列表选项
    getShanghuList(val) {
      if (val) {
        this.getShanghu();
      }
    },
    // 查询条件整理
    getQueryForm() {
      const queryForm = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          name: this.queryForm.params.name,
          queryStartDate: null,
          queryEndDate: null,
          customerIds: this.queryForm.params.customerIds,
          merchantCodes: this.queryForm.params.merchantCodes,
          locations: []
        }
      };
      if (this.queryForm.params.invoiceIssueTime && this.queryForm.params.invoiceIssueTime.length) {
        queryForm.params.queryStartDate = this.queryForm.params.invoiceIssueTime[0];
        queryForm.params.queryEndDate = this.queryForm.params.invoiceIssueTime[1];
      }
      if (this.queryForm.params.locations && this.queryForm.params.locations.length > 0) {
        this.queryForm.params.locations.map(item => {
          const provinceAndCity = {
            state: item[0],
            city: item.length > 1 ? item[1] : ''
          };
          queryForm.params.locations.push(provinceAndCity);
        });
      }
      return queryForm;
    },
    // 获取列表数据
    getTableData() {
      holidayPage(this.getQueryForm()).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            const endDate = new Date(item.endDate).getTime();
            const currentDate = new Date().getTime();
            if (endDate < currentDate) {
              item.isExpired = true;
            }
          });
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 重置
    onReset() {
      this.queryForm.params = {
        name: null,
        type: null,
        invoiceIssueTime: [],
        targetCustomerIds: [],
        targetMerchantCodes: [],
        targetLocations: []
      };
    },
    // 获取配置名称查询条件
    getNameData() {
      holidayNameApi(null, false).then(res => {
        if (res.code === 200) {
          this.nameList = res.data;
        }
      });
    },
    // 新增节假日
    addHoliday() {
      this.addEditType = 1;
      this.dataDetail = {
        name: '',
        date: [],
        type: null,
        targetLocations: [],
        targetCustomerIds: [],
        targetMerchantCodes: []
      };
      this.showDataDetailWindow = true;
      this.abnormalKey = new Date().getTime();
    },
    // 修改节假日
    editHoliday(data) {
      this.addEditType = 2;
      const rowData = JSON.parse(JSON.stringify(data));
      const stateCity = [];
      if (rowData.targetLocations && rowData.targetLocations.length > 0) {
        rowData.targetLocations.map(item => {
          if (item.state && item.city) {
            stateCity.push([item.state, item.city]);
          } else if (item.state && !item.city) {
            stateCity.push([item.state]);
          }
        });
      }
      this.dataDetail = {
        id: rowData.id,
        name: rowData.name,
        date: [rowData.startDate, rowData.endDate],
        type: rowData.type,
        targetLocations: stateCity,
        targetCustomerIds: rowData.targetCustomerIds || [],
        targetMerchantCodes: rowData.targetMerchantCodes || []
      };
      this.selectedCustomerList = rowData.customerInfoList;
      rowData.merchantInfoList.map(item => {
        this.merchantList.push({
          value: item.merchantCode,
          code: item.merchantCode,
          label: `${item.merchantName}(${item.merchantCode})`
        });
      });
      this.showDataDetailWindow = true;
      this.abnormalKey = new Date().getTime();
    },
    // 删除节假日
    deleteHoliday(data) {
      this.$confirm(this.$t('GlobalSetObj.AreYouSureDelete'), this.$t('GlobalSetObj.tips'), {
        confirmButtonText: this.$t('spareNumberPoo.confirm'),
        cancelButtonText: this.$t('spareNumberPoo.cancel'),
        type: 'warning'
      }).then(() => {
        holidayDelete(data.id).then(() => {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          this.updateTable();
        });
      });
    },
    // 更新列表
    updateTable() {
      this.showDataDetailWindow = false;
      this.getTableData();
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 保存编辑
    confirmSave() {
      this.$refs.addEditDetailRef.submitSave();
    },
    // 查看州或城市
    getStateOrCityPage(row) {
      this.detailType = 1;
      this.detailTableData = row.targetLocations;
      this.showDetailWindow = true;
      this.$nextTick(() => {
        this.$refs.detailTableRef.doLayout();
      });
    },
    // 查看客户
    getClientPage(row) {
      this.detailType = 2;
      this.detailTableData = row.customerInfoList;
      this.showDetailWindow = true;
      this.$nextTick(() => {
        this.$refs.detailTableRef.doLayout();
      });
    },
    // 查看商户
    getCommercialOwnerPage(row) {
      this.detailType = 3;
      this.detailTableData = row.merchantInfoList;
      this.showDetailWindow = true;
      this.$nextTick(() => {
        this.$refs.detailTableRef.doLayout();
      });
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 获取商户
    getShanghu(name = '') {
      this.commercialList = [];
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: name,
          customerIds: this.queryForm.params.customerIds
        }
      };
      apimerchantName(param).then((res) => {
        if (res.code === 200) {
          this.commercialList = res.data.records.map(item => {
            return {
              value: item.merchantCode,
              code: item.merchantCode,
              label: `${item.merchantName}(${item.merchantCode})`
            };
          });
        }
      });
    },
    // 获取省和市
    getProvinceAndCity() {
      provinceAndCityApi().then((res) => {
        if (res.code === 200) {
          this.stateCityOptions = this.convertToCascadeFormat(res.data);
        }
      });
    },
    // 将获取的州省城市转为级联格式
    convertToCascadeFormat(data) {
      return Object.keys(data).map(state => ({
        value: state,
        label: state,
        children: data[state].map(city => ({
          value: city,
          label: city
        }))
      }));
    }
  }
};
</script>

<style scoped>
.search-form .el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>
